'use strict';

module.exports = '3.35.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 213
// module chunks = 168707334958949